<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2020-03-28 16:14:33
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-11 14:34:08
-->
<template>
  <div class="right-content">
    <!-- 内容 -->
    <div v-if="crumbs" class="crumbs-box">
      <div v-if="iconName=='内容'"><i class="ri-article-fill icon-text"></i></div>
      <div v-if="iconName=='互动'"><i class="ri-message-fill icon-text"></i></div>
      <div v-if="iconName=='配置'"><i class="ri-folder-settings-fill icon-text"></i></div>
      <div v-if="iconName=='用户'"><i class="ri-team-fill icon-text"></i></div>
      <div v-if="iconName=='统计'"><i class="ri-database-2-fill icon-text"></i></div>
      <div v-if="iconName=='系统'"><i class="ri-settings-4-fill icon-text"></i></div>
      <div class="crumbs">{{crumbs}}</div>
    </div>
     <div class="content">
          <div class="box-body"> <router-view /></div>
        </div>
  </div>
</template>

<script>
// 引入组件
import menus from "@/utils/route";

export default {
  data() {
    return {
      crumbs: "",
      iconName:'',
    };
  },
  components: {},
  created() {
    this.changeCrumbs();
  },
  methods: {
    changeCrumbs() {
      if(this.$route.path == '/index/403'){
          this.crumbs = '无权限页';
      }else{
          menus.forEach((element, index) => {
          if (element.children) {
            element.children.forEach((twoElement, twoIndex) => {
              twoElement.group.forEach((threeElement, threeIndex) => {
                if (threeElement.children && this.$route.query.islast) {
                  threeElement.children.forEach((fourElement, fourIndex) => {
                    if (fourElement.path == this.$route.path) {
                      //this.crumbs = `<strong><span style="color:#ccc">${element.title} / ${element.children[twoIndex].groupName} / ${threeElement.title}</span></strong> / <strong>${fourElement.title}</strong>`;
                      this.crumbs = `${fourElement.title}`;
                    }
                  });
                } else {
                  if (threeElement.path == this.$route.path) {
                    this.crumbs = `${threeElement.title}`;
                    this.iconName = element.title;
                  }
                }
              });
            });
          } else {
            if (element.path == this.$route.path) {
              this.crumbs = "";
            }
          }
      });
      }
    },
  },
  watch: {
    $route() {
        this.changeCrumbs();
    },
  },
};
</script>

<style lang="less" scoped>
.right-content {
  width: calc(100% - 220px);
  background-color: #f0f2f5;
  display: flex;
  flex-direction: column;
  //padding: 24px;
  padding-bottom: 0px;
  min-width: 1200px;
  flex: 1;

  .content {
    flex: 1;
    //padding: 10px;
    //box-sizing: border-box;
    //overflow-y: scroll;
    background: #f0f2f5;
    padding-left: 24px;
    padding-right: 24px;
   // margin-top: 12px;
    // border-top-left-radius: 10px;
    // border-top-right-radius: 10px;
    
  }
  .box-body{
     background: #fff;
     position: relative;
     height: 100%;
  }
  .crumbs {
    color: rgba(102, 111, 128, 1);
    font-size: 16px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .crumbs-box {
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    font-family: Roboto;
    border: 1px solid rgba(229, 229, 229, 1);
    height: 50px;
    padding-left: 40px;
  }
  .icon {
    margin-bottom: 5px;
    margin-right: 6px;
  }
}
.di_biao{
  font-size: 18px;
  font-weight: 600;
  margin-top: -4px;
  margin-right: 5px;
}
.icon-text{
  color: rgba(151, 161, 175, 1);
  font-size: 20px;
  margin-right: 6px;
}
</style>
